export default {
  plugins: {
    zh: '插件',
    en: 'Plugins',
  },
  plugin: {
    zh: '插件',
    en: 'Plugin',
  },
  createPlugin: {
    zh: '创建插件',
    en: 'Create plugin',
  },
  viewPlugin: {
    zh: '查看插件',
    en: 'View plugin',
  },
  file: {
    zh: '文件',
    en: 'File',
  },
  deleteNotice: {
    zh: '注意：删除插件将需要重新启动 kuiper 才能生效。',
    en: 'Note: drop a plugin will need to restart kuiper to take effect.',
  },
  typeRequired: {
    zh: '请选择类型',
    en: 'Type is required',
  },
  nameRequired: {
    zh: '请填写名称',
    en: 'Name is required',
  },
  fileRequired: {
    zh: '请输入文件的 URL 地址',
    en: 'File is required',
  },
  shellParamsRequired: {
    zh: '请填写脚本参数',
    en: 'Script parameters is required',
  },
  TDenginePlaceholder: {
    zh: '输入 TDengine 服务器版本，例如 2.7.0.0，回车键创建新版本',
    en: 'TDengine server version, e.g 2.7.0.0, enter key to create a new version',
  },
  betaTip: {
    zh: '该插件为测试版本',
    en: 'This plugin is a Beta version',
  },
  installed: {
    zh: '已安装',
    en: 'Installed',
  },
  installPlugins: {
    zh: '安装插件',
    en: 'Install plugin',
  },
  installTip: {
    zh: '该插件暂未安装，点击跳转到插件页面安装',
    en: 'This plugin is not installed yet, click to jump to the plugins page to install',
  },
  typeFirst: {
    zh: '请先选择插件类型',
    en: 'Please select plugin type first',
  },
  selectOrInput: {
    zh: '请选择或输入插件名称',
    en: 'Please select or enter the plugin name',
  },
  shellParas: {
    zh: '脚本参数',
    en: 'Script parameters',
  },
  shellParasDesc: {
    zh: '安装插件脚本额外的参数配置',
    en: 'Extension parameter configuration of the script to install the plugin',
  },
  functions: {
    zh: '插件函数',
    en: 'Functions',
  },
  functionsDesc: {
    zh: '安装函数插件时，需注册的函数（支持多选）',
    en: 'Functions that need to be registered when installing the function plug-in (multiple choice supported)',
  },
  registerFunction: {
    zh: '注册函数',
    en: 'Register Functions',
  },
  functionsRequired: {
    zh: '请选择函数',
    en: 'Functions is required',
  },
  portable: {
    zh: '便捷插件',
    en: 'Portable',
  },
  createPortable: {
    zh: '创建便捷插件',
    en: 'Create portable',
  },
  updatePortable: {
    zh: '更新便捷插件',
    en: 'Update portable',
  },
  fileWarningMessage: {
    zh: '警告：如果您的主机 CPU arch 是 arm64，请将文件名替换为',
    en: 'Warning: if your host machine CPU arch is arm64,please replace the filename with',
  },
  deletePortableWarning: {
    zh: '请确保所有使用该插件的规则都已关闭，否则可能出现错误。',
    en: 'Please make sure all rules using the plugin are closed or they may have errors.',
  },
}
